export const replaceNewlinesWithBr = text => text.replace(/\n/g, '<br />');

export const textToHtmlAttribute = (text, replaceNewlines = false) => ({
  dangerouslySetInnerHTML: { __html: replaceNewlines ? replaceNewlinesWithBr(text) : text }
});

export default textToHtmlAttribute;
